import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import HelpService from 'services/HelpService';

export const initialState = {
  loading: false,
  message: '',
  showMessage: false,
  data: {
    all: [],
    count: 0,
  },
};

export const getHelp = createAsyncThunk(
  'help/getHelp',
  async (page, { rejectWithValue }) => {
    try {
      const response = await HelpService.getHelp(page);
      if (response.status) {
        return response.data;
      }
      return rejectWithValue(response.message || 'Error');
    } catch (err) {
      return rejectWithValue(err.message || 'Error');
    }
  }
);

export const resolveHelp = createAsyncThunk(
  'help/resolveHelp',
  async (data, { rejectWithValue }) => {
    try {
      const response = await HelpService.resolveHelp(data);
      if (response.status) {
        return response.data;
      }
      return rejectWithValue(response.message || 'Error');
    } catch (err) {
      return rejectWithValue(err.message || 'Error');
    }
  }
);

export const helpSlice = createSlice({
  name: 'help',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getHelp.pending, (state) => {
        state.loading = true;
        state.message = '';
      })
      .addCase(getHelp.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.message = '';
      })
      .addCase(getHelp.rejected, (state, action) => {
        state.message = action.payload;
        state.showMessage = true;
        state.loading = false;
      })
      .addCase(resolveHelp.pending, (state) => {
        state.loading = true;
      })
      .addCase(resolveHelp.fulfilled, (state) => {
        state.loading = false;
        state.message = 'Help request updated';
      })
      .addCase(resolveHelp.rejected, (state, action) => {
        state.message = action.payload;
        state.showMessage = true;
        state.loading = false;
      });
  },
});

export default helpSlice.reducer;
